import React from 'react'

import { CurrentLiabiliiesCards } from './Cards'

export const LiabilityTabs = () => {
  return (
    <CurrentLiabiliiesCards />
  )
}
